import AModal from './a-modal.vue'

export default AModal
